import { createAction, createReducer } from '@reduxjs/toolkit';
import omit from 'transmute/omit';
import { fetchSettings, saveModifiedSettings } from '../actions/SettingsActions';
import { USER_ATTRIBUTE_DEFAULT_DUE_DATE_PRESET, USER_ATTRIBUTE_DEFAULT_DUE_TIME, USER_ATTRIBUTE_DEFAULT_REMINDER_PRESET, USER_ATTRIBUTE_HIDE_FOLLOW_UP_TASKS, USER_ATTRIBUTE_HIDE_LEAD_FOLLOW_UP_TASKS } from '../constants/UserAttributesKeys';
export const resetStagedSettings = createAction('resetStagedSettings');
export const updateHideFollowUpPopoverSetting = createAction('updateHideFollowUpPopoverSetting');
export const updateHideLeadFollowUpPopoverSetting = createAction('updateHideLeadFollowUpPopoverSetting');
export const updateDefaultDueDatePresetSetting = createAction('updateDefaultDueDatePresetSetting');
export const updateDefaultDueTimeSetting = createAction('updateDefaultDueTimeSetting');
export const updateDefaultReminderPresetSetting = createAction('updateDefaultReminderPresetSetting');
const initialState = {};
const stagedSettingsReducer = createReducer(initialState, builder => {
  builder.addCase(fetchSettings.fulfilled, () => ({})).addCase(saveModifiedSettings.fulfilled, (state, action) => {
    return omit(Object.keys(action.payload), state);
  }).addCase(resetStagedSettings, () => ({})).addCase(updateHideFollowUpPopoverSetting, (state, action) => {
    state[USER_ATTRIBUTE_HIDE_FOLLOW_UP_TASKS] = action.payload;
  }).addCase(updateHideLeadFollowUpPopoverSetting, (state, action) => {
    state[USER_ATTRIBUTE_HIDE_LEAD_FOLLOW_UP_TASKS] = action.payload;
  }).addCase(updateDefaultDueDatePresetSetting, (state, action) => {
    state[USER_ATTRIBUTE_DEFAULT_DUE_DATE_PRESET] = action.payload;
  }).addCase(updateDefaultDueTimeSetting, (state, action) => {
    state[USER_ATTRIBUTE_DEFAULT_DUE_TIME] = action.payload;
  }).addCase(updateDefaultReminderPresetSetting, (state, action) => {
    state[USER_ATTRIBUTE_DEFAULT_REMINDER_PRESET] = action.payload;
  });
});
export default stagedSettingsReducer;